module.exports = __webpack_public_path__ + "img/223.ea3beff7.png";